import { render, staticRenderFns } from "./DisplayLayoutBox.vue?vue&type=template&id=fcbf4f5c&lang=pug"
import script from "./DisplayLayoutBox.vue?vue&type=script&lang=js"
export * from "./DisplayLayoutBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports